import React, { useState } from 'react';

import AsyncSelect from 'react-select/async';
import { components } from 'react-select';

import Button from 'components/lib/Button';
import Icon from 'components/lib/Icon';
import Text from 'components/lib/Text';

import { request } from 'core/constants';

import { Container, Modal, ModalBody, ModalHeader, ButtonContainer, CurrentCreatorInfo } from './styles';

const ChangeCreatorModal = ({
  title = 'Alterar Responsável',
  currentCreator = null,
  entityType = '',
  entityId = null,
  companyId = null,
  onClose = () => {},
  onSuccess = () => {},
  onNotification = () => {},
}) => {
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const endpointMap = {
    'property-owner': 'property-owner',
    'client': 'client',
    'guarantor': 'guarantor',
  };

  const promiseOptions = (inputValue) =>
    new Promise((resolve, reject) => {
      request
        .get('{company}/user?search=' + inputValue)
        .then((response) => {
          resolve(response.data)
        })
        .catch(() => reject())
    });

  const DropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
      <Icon name='fas fa-user' />
    </components.DropdownIndicator>
  );

  const Option = (props) => {
    const data = props.data || {};

    return (
      <components.Option {...props}>
        <Text>
          <strong>{data.name || 'Sem nome'}</strong> -{' '}
          {(
            (data.profiles && data.profiles.concat().map((item) => item.name)) ||
            []
          ).join(', ')}
        </Text>
        <Text isSmall>{data.email}</Text>
      </components.Option>
    );
  };

  const LoadingIndicator = () => null;

  const handleSave = async () => {
    if (!selectedUser) return;

    setLoading(true);

    const endpoint = endpointMap[entityType];

    try {
      await request.patch(
        `/company/${companyId}/${endpoint}/${entityId}`,
        { creator: { id: selectedUser.id } }
      );

      onNotification({
        message: 'Responsável alterado com sucesso',
        status: 'success',
      });

      onSuccess();
      onClose();
    } catch (error) {
      if (error.status === 403) {
        onNotification({
          message: 'Você não tem permissão para alterar o responsável',
          status: 'danger',
        });
      } else if (error.status === 422) {
        const message =
          error.errors && error.errors[0]
            ? error.errors[0].message
            : 'Erro de validação';
        onNotification({
          message,
          status: 'danger',
        });
      } else {
        onNotification({
          message: error.message || 'Erro ao alterar o responsável',
          status: 'danger',
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => (!loading ? onClose() : undefined);

  const currentCreatorName = currentCreator
    ? currentCreator.name || currentCreator.email || 'Sistema'
    : 'Sistema';

  return (
    <Container onClick={handleClose}>
      <Modal onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <span>{title}</span>

          <div
            aria-hidden="true"
            onClick={handleClose}
            style={{ cursor: 'pointer' }}
          >
            <Icon name="fal fa-times" />
          </div>
        </ModalHeader>
        <ModalBody>
          <CurrentCreatorInfo>
            <Icon name="fas fa-user-circle" />
            Responsável atual: <span>{currentCreatorName}</span>
          </CurrentCreatorInfo>

          <div>
            <label style={{ display: 'block', marginBottom: 6, fontSize: 14, color: '#5f6775' }}>
              Selecionar novo responsável
            </label>
            <div className='react-select-wrapper'>
              <AsyncSelect
                defaultOptions
                classNamePrefix='react-select'
                name='creator'
                isMulti={false}
                isDisabled={loading}
                isLoading={loading}
                loadingMessage={() => 'Pesquisando por usuários...'}
                noOptionsMessage={() => <span>Nenhum usuário encontrado</span>}
                placeholder='Digite para buscar...'
                maxMenuHeight={162}
                minMenuHeight={100}
                onChange={(option) => setSelectedUser(option)}
                isClearable={false}
                getOptionLabel={(option) => option.name || option.email || ''}
                getOptionValue={(option) => option.id}
                components={{
                  DropdownIndicator,
                  LoadingIndicator,
                  Option,
                }}
                loadOptions={promiseOptions}
              />
            </div>
          </div>

          <ButtonContainer>
            <Button isNeutral disabled={loading} onClick={handleClose}>
              Cancelar
            </Button>
            <Button
              hasThemeColor
              disabled={loading || !selectedUser}
              onClick={handleSave}
              isLoading={loading}
            >
              Salvar
            </Button>
          </ButtonContainer>
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default ChangeCreatorModal;
